export default __webpack_public_path__ + "static/media/adForSchool.fe31e38e.png";